import Vue from "vue"
import Vuetify from "vuetify/lib/framework"
import { preset } from "./preset";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCheck, faSquare, faAngleRight, faAngleLeft, faDotCircle, faCircle, faUserCircle, faSignOut, faEnvelopeOpen, faBars, faTimes
} from '@fortawesome/pro-regular-svg-icons'

import {
  faCheckSquare, faCaretDown, faTimesCircle, faEdit, faExclamationTriangle, faSearch, faChevronLeft, faChevronRight, faCheckCircle
} from '@fortawesome/pro-solid-svg-icons'

import { faChevronDown, faHome, faWindowClose, faCoins, faMapMarkerAlt } from '@fortawesome/pro-light-svg-icons'

Vue.use(Vuetify);
Vue.component("font-awesome-icon", FontAwesomeIcon)

library.add(faSquare);
library.add(faCheckSquare);
library.add(faCaretDown);
library.add(faTimesCircle);
library.add(faEdit);
library.add(faSquare);
library.add(faCheck);
library.add(faAngleRight);
library.add(faAngleLeft);
library.add(faDotCircle);
library.add(faCircle);
library.add(faExclamationTriangle);
library.add(faSearch);
library.add(faChevronDown);
library.add(faChevronLeft);
library.add(faChevronRight);
library.add(faCheckCircle);
library.add(faHome);
library.add(faUserCircle);
library.add(faSignOut);
library.add(faEnvelopeOpen);
library.add(faBars);
library.add(faTimes);
library.add(faWindowClose);
library.add(faMapMarkerAlt);
library.add(faCoins);

export default new Vuetify({
  preset,
  icons: {
    iconfont: "faSvg",
    values: {
      home:  {
        component: FontAwesomeIcon,
        props: {
          icon: ["fal", "home"]
        }
      },
      user:  {
        component: FontAwesomeIcon,
        props: {
          icon: ["far", "user-circle"]
        }
      },
      edit:  {
        component: FontAwesomeIcon,
        props: {
          icon: ["fas", "edit"]
        }
      },
      check: {
        component: FontAwesomeIcon,
        props: {
          icon: ["far", "check"]
        }
      },
      checkboxOn: {
        component: FontAwesomeIcon,
        props: {
          icon: ["fas", "check-square"]
        }
      },
      checkboxOff: {
        component: FontAwesomeIcon,
        props: {
          icon: ["far", "square"]
        }
      },
      search: {
        component: FontAwesomeIcon,
        props: {
          icon: ["fas", "search"]
        }
      },
      logout: {
        component: FontAwesomeIcon,
        props: {
          icon: ["far", "sign-out"]
        }
      },
      expand: {
        component: FontAwesomeIcon,
        props: {
          icon: ["fal", "chevron-down"]
        }
      },
      inquiry: {
        component: FontAwesomeIcon,
        props: {
          icon: ["far", "envelope-open"]
        }
      },
      bars: {
        component: FontAwesomeIcon,
        props: {
          icon: ["far", "bars"]
        }
      },
      clear: {
        component: FontAwesomeIcon,
        props: {
          icon: ["far", "times"]
        }
      },
      close: {
        component: FontAwesomeIcon,
        props: {
          icon: ["fal", "window-close"]
        }
      },
      mapMarkerAlt: {
        component: FontAwesomeIcon,
        props: {
          icon: ["fal", "map-marker-alt"]
        }
      },
      coins: {
        component: FontAwesomeIcon,
        props: {
          icon: ["fal", "coins"]
        }
      },
    }
  }
});
